/**
 * @description 用户/登录-注册相关接口
 */
import request from '@/utils/http.js';
// import env from './env'; //未使用

const biz_id = 2; // TODO: 目前只有化蝶使用,后续联调中台接口处理

// 获取易盾配置
const getCapthaKey = (params = {}) => {
  const capthaKey = 'b7982ef659d64141b7120a6af27e19a0';
  return Promise.resolve(capthaKey);
};

// 发送验证码(c端)
const sendCode = (params = {}) => {
  const retParmams = {
    type: 1,
    scene_id: 7,
    biz_id: biz_id,
    ...params
  };
  if (biz_id === 4) {
    retParmams.validate_type = 2; // 知客的交互方式不同
  }
  return request({
    url: '/v3/users/code-consumer/send',
    method: 'POST',
    data: retParmams
  });
};

// 登录(c端)
const userLogin = (params = {}, withCookie = false) => {
  return request({
    url: '/v3/users/user-consumer/login',
    method: 'POST',
    data: params,
    withCredentials: withCookie
  });
};

// 账号检查(c端)
const loginCheck = (params = {}) => {
  return request({
    url: '/v3/users/user/login-check',
    method: 'POST',
    data: params
  });
};

// 获取登录秘钥
function getKeyLogin() {
  return request({
    url: '/v3/users/user/get-key-login',
    method: 'POST'
  });
}

// 注册
const register = (params = {}) => {
  return request({
    url: '/v3/users/user-consumer/register',
    method: 'POST',
    data: {
      biz_id: biz_id,
      ...params
    }
  });
};

// 账号登录&&验证码登录
const loginInfo = (params = {}) => {
  return request({
    url: '/v3/users/user-consumer/login',
    method: 'POST',
    data: params
  });
};

// 获取控制台标志信息
const extendsLoginInfo = (params = {}) => {
  return request({
    url: '/v3/users/user-extends/get-logo-info',
    method: 'POST',
    data: {
      biz_id,
      ...params
    }
  });
};

// 退出登录
const loginOut = (params = {}, withCookie = false) => {
  return request({
    url: '/v3/users/user/logout',
    method: 'POST',
    data: params,
    withCredentials: withCookie // 携带cookie
  });
};

// 角色退出
const loginRoleOut = (params = {}) => {
  return request({
    url: '/v3/webinars/live/role-logout',
    method: 'POST',
    data: params
  });
};

// 第三方授权
const oauthCallback = (params = {}, withCookie = false) => {
  return request({
    url: '/v3/users/oauth/callback',
    method: 'POST',
    data: params,
    withCredentials: withCookie
  });
};

//微信授权接口获取
const authWeixinAjax = (params = {}) => {
  return request({
    url: '/v3/commons/auth/weixin-ajax',
    method: 'GET',
    params: params
  });
};

// 手机||邮箱验证码
const codeCheck = (params = {}) => {
  return request({
    url: '/v3/users/code-consumer/check',
    method: 'POST',
    data: { biz_id, ...params }
  });
};

// 密码重置
const resetPassword = (params = {}) => {
  return request({
    url: '/v3/users/user-consumer/reset-password',
    method: 'POST',
    data: params
  });
};

// 获取用户信息
// v7.9.3 接口变更 http://yapi.vhall.domain/project/100/interface/api/56514
const getUserInfo = (data = {}) => {
  return request({
    url: '/v3/users/user-consumer/info',
    method: 'POST',
    data: { biz_id, ...data }
  });
};

// 更换用户头像
const changeAvatarSend = (data = {}) => {
  return request({
    url: '/v3/users/user-consumer/edit',
    method: 'POST',
    data: { biz_id, ...data }
  });
};

// 替换昵称
const editUserNickName = (data = {}) => {
  return request({
    url: '/v3/users/user-consumer/edit',
    method: 'POST',
    data: { biz_id, ...data }
  });
};

// 第三方解除绑定
const thirdUnbind = (data = {}) => {
  return request({
    url: '/v3/users/oauth/unbind',
    method: 'POST',
    data: { biz_id, ...data }
  });
};

// 绑定手机号
const bindInfo = (data = {}) => {
  return request({
    url: '/v3/users/user-consumer/bind-info',
    method: 'POST',
    data: { biz_id, ...data }
  });
};

// 绑定手机号(新)
// http://yapi.vhall.domain/project/100/interface/api/56532?from_wecom=1
const bindPhone = (data = {}) => {
  return request({
    url: '/v3/users/user-consumer/bind-phone',
    method: 'POST',
    data: data
  });
};

//通用上传图片
const uploadImage = (data = {}) => {
  return request({
    url: '/v3/commons/upload/index',
    method: 'POST',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

//刷新token
const refreshToken = (params = {}) => {
  const url = '/v3/users/user/refresh-token';
  return request({
    url,
    method: 'POST',
    data: params
  });
};

//口令登录
function roleLogin(params = {}) {
  return request({
    url: '/v3/webinars/live/role-login',
    method: 'GET',
    params: params
  });
}

// sso自动登录
function ssoAutoLogin(data = {}, withCookie = true) {
  return request({
    url: '/v3/users/user/auto-login',
    method: 'POST',
    data: {
      biz_id,
      ...data
    },
    withCredentials: withCookie // 默认携带cookie
  });
}
/**
 * 获取b端用户配置的全局嵌入链接
 * @param {*} params business_uid b端用户id和 config_type 固定值0代表链接
 * @returns
 */
const getBusinessDomainConfigList = (params = {}) => {
  return request({
    url: '/v1/ucenter/app/business/get-config-list',
    method: 'POST',
    data: params
  });
};


// 微信登录(c端)
const wechatLogin = (params = {}, withCredentials = false) => {
  return request({
    url: '/v1/ucenter/app/user/wx-verify-login',
    method: 'POST',
    data: params,
    withCredentials
  });
};

export default {
  getCapthaKey,
  sendCode,
  userLogin,
  loginCheck,
  register,
  getKeyLogin,
  loginInfo,
  loginOut,
  loginRoleOut,
  oauthCallback,
  codeCheck,
  resetPassword,
  getUserInfo,
  changeAvatarSend,
  editUserNickName,
  thirdUnbind,
  bindInfo,
  bindPhone,
  uploadImage,
  roleLogin,
  authWeixinAjax,
  ssoAutoLogin,
  refreshToken,
  extendsLoginInfo,
  getBusinessDomainConfigList,
  wechatLogin
};
